import { AccountCircle, Dashboard, Description, LocationOn, Logout } from '@mui/icons-material';
import Contacts from '@mui/icons-material/Contacts';
import GroupsIcon from '@mui/icons-material/Groups';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import React from 'react';
import { Link } from "react-router-dom";
import Colors from '../colors';
import { logout } from '../firebase';

function RightDrawer(props) {
  const { open, toggleDrawer } = props;

  const dashboardName = 'Dashboard';
  const tailgateName = 'Tailgate';
  const accountName = 'Account';
  const teamsName = 'Teams';
  const contactsName = 'Contacts';
  const locationsName = 'Locations';
  const primaryColor = Colors.black;
  const logoutName = 'Logout';

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={toggleDrawer}
    >
      <Box
        sx={{ width: 250 }}
        role="presentation"
        onClick={toggleDrawer}
        onKeyDown={toggleDrawer}
      >
        <List>
          <Link to={`/`} style={{ textDecoration: 'none', color: primaryColor }}>
            <ListItem key={dashboardName} disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  <Dashboard sx={{ color: Colors.red }} />
                </ListItemIcon>
                <ListItemText primary={dashboardName} />
              </ListItemButton>
            </ListItem>
          </Link>
          <Link to={`/tailgate-forms`} style={{ textDecoration: 'none', color: primaryColor }}>
            <ListItem key={tailgateName} disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  <Description sx={{ color: Colors.green }} />
                </ListItemIcon>
                <ListItemText primary={tailgateName} />
              </ListItemButton>
            </ListItem>
          </Link>
          <Link to={`teams`} style={{ textDecoration: 'none', color: primaryColor }}>
            <ListItem key={teamsName} disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  <GroupsIcon sx={{ color: Colors.blue }} />
                </ListItemIcon>
                <ListItemText primary={teamsName} />
              </ListItemButton>
            </ListItem>
          </Link>

          <Link to={`contacts`} style={{ textDecoration: 'none', color: primaryColor }}>
            <ListItem key={contactsName} disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  <Contacts sx={{ color: Colors.orange }} />
                </ListItemIcon>
                <ListItemText primary={contactsName} />
              </ListItemButton>
            </ListItem>
          </Link>
          <Link to={`locations`} style={{ textDecoration: 'none', color: primaryColor }}>
            <ListItem key={locationsName} disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  <LocationOn sx={{ color: Colors.red }} />
                </ListItemIcon>
                <ListItemText primary={locationsName} />
              </ListItemButton>
            </ListItem>
          </Link>
          <Link to={`account`} style={{ textDecoration: 'none', color: primaryColor }}>
            <ListItem key={accountName} disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  <AccountCircle sx={{ color: Colors.purple }} />
                </ListItemIcon>
                <ListItemText primary={accountName} />
              </ListItemButton>
            </ListItem>
          </Link>
          <ListItem key={logoutName} disablePadding onClick={logout}>
            <ListItemButton>
              <ListItemIcon>
                <Logout sx={{ color: primaryColor }} />
              </ListItemIcon>
              <ListItemText primary={logoutName} />
            </ListItemButton>
          </ListItem>
        </List>
      </Box>
    </Drawer>
  );
}

export default RightDrawer;
